module.exports = __webpack_public_path__ + "481abd9148f8898f66ae37def6e9b47f.svg";